/*
 *
 * Module reducer
 *
 */

export const Types = {
  // Obtem módulos
  GET_REQUEST: 'reports-activities-done/GET_REQUEST',
  GET_SUCCESS: 'reports-activities-done/GET_SUCCESS',
  GET_FAILURE: 'reports-activities-done/GET_FAILURE',
};

export const initialState = {
  // Lista de módulos
  data: [],
  loading: false,
  error: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    // Lista de módulos
    case Types.GET_REQUEST:
      return { ...state, loading: true };
    case Types.GET_SUCCESS:
      return {
        ...state,
        data: action.payload.data,
        loading: false,
        error: null,
        total: action.payload.total,
      };
    case Types.GET_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export const Creators = {
  // Busca lista de módulos
  getRequest: formData => ({
    type: Types.GET_REQUEST,
    payload: formData,
  }),
  getSuccess: ({ data, total }) => ({
    type: Types.GET_LIST_SUCCESS,
    payload: { data, total },
  }),
  getFailure: error => ({
    type: Types.GET_LIST_FAILURE,
    payload: error,
  }),
};
